import { Component, OnInit } from '@angular/core';
import { AdminService, AdminUsersFilter } from '../../../../@shared/services/admin.service';
import { AdminUserResponse } from '../../../../@shared/models/response.module';

@Component({
  selector: 'app-admin-users',
  standalone: false,
  templateUrl: './admin-users.html',
  styleUrl: './admin-users.css'
})
export class AdminUsers implements OnInit {
  loading: boolean = true;
  users: AdminUserResponse[] = [];
  Math = Math; // Make Math available in template

  // Pagination
  currentPage: number = 1;
  perPage: number = 20;
  totalItems: number = 0;
  totalPages: number = 0;

  // Filters
  searchQuery: string = '';
  activeOnly: boolean = false;
  trainersOnly: boolean = false;
  sortBy: string = 'created_at';
  sortOrder: 'asc' | 'desc' = 'desc';

  constructor(private adminService: AdminService) {}

  ngOnInit() {
    this.loadUsers();
  }

  loadUsers() {
    this.loading = true;

    const filters: AdminUsersFilter = {
      page: this.currentPage,
      per_page: this.perPage,
      order_by: this.sortBy,
      sort: this.sortOrder,
      compact: false
    };

    if (this.searchQuery) {
      filters.search = this.searchQuery;
    }

    if (this.activeOnly) {
      filters.active_only = true;
    }

    if (this.trainersOnly) {
      filters.is_trainer = true;
    }

    this.adminService.getUsers(filters).subscribe({
      next: (response) => {
        this.users = response.data;
        this.totalItems = response.total_items;
        this.totalPages = response.total_pages;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onSearch() {
    this.currentPage = 1;
    this.loadUsers();
  }

  onFilterChange() {
    this.currentPage = 1;
    this.loadUsers();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadUsers();
  }

  onSort(column: string) {
    if (this.sortBy === column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortBy = column;
      this.sortOrder = 'desc';
    }
    this.loadUsers();
  }

  getSortIcon(column: string): string {
    if (this.sortBy !== column) return 'fa-sort';
    return this.sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  getPages(): number[] {
    const pages: number[] = [];
    const maxPages = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
    let end = Math.min(this.totalPages, start + maxPages - 1);

    if (end - start + 1 < maxPages) {
      start = Math.max(1, end - maxPages + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}
